import { Observable } from '@reactivex/rxjs'
import { fromJS } from 'immutable'
import { update$ } from './firebase-init'
import { fake$ } from './fake'
import { selected$ } from './selected-sample'

const initialState = fromJS({ samples: [], count: 0 })
const store$ = Observable.merge(update$, fake$, selected$)
  .startWith(initialState)
  .scan((state, changeFn) => changeFn(state))
  .share()

export default store$



// WEBPACK FOOTER //
// ./store.js